import ReassignTasksWrapper from './ReassignTasksWrapper';

export default ReassignTasksWrapper;
